import { render, staticRenderFns } from "./ProtocolsTable.vue?vue&type=template&id=1e9868a1&scoped=true&"
import script from "./ProtocolsTable.vue?vue&type=script&lang=js&"
export * from "./ProtocolsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolsTable.vue?vue&type=style&index=0&id=1e9868a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9868a1",
  null
  
)

export default component.exports